"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deep = void 0;

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Invokes a function against every object or item in an array
 * @param {object | object[]} obj
 * @param {(...args) => any} mapper
 */
var deep = function deep(obj, mapper) {
  if ((0, _isArray.default)(obj)) {
    return obj.map(function (value) {
      return deep(value, mapper);
    });
  }

  if ((0, _isPlainObject.default)(obj)) {
    return (0, _mapValues.default)(mapper(obj), function (value) {
      return deep(value, mapper);
    });
  }

  return obj;
};

exports.deep = deep;
//# sourceMappingURL=deep.js.map